import { mutateSkills } from '../../mutations/mutateSkills';
import { organizationAPI } from 'api/phases/endpoints';

export const removeSkill = async (skillId: number) => {
  await organizationAPI.deleteSkill(skillId);
  await mutateSkills();
};
